<template>
  <div
    id="modaEditRegistry"
    class="modal fade"
    tabindex="-1"
    data-keyboard="false"
    data-backdrop="static"
  >
    <div class="modal-dialog" :class="sizeModal">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Atualizar</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          >
            &times;
          </button>
        </div>
        <form @submit.prevent="updateRegistry">
          <div class="modal-body">
            <div v-if="field === 'numero'" class="form-group">
              <label>
                Nº do Registro (consultar o SGQ):
                <span class="text-danger">*</span>
              </label>
              <input
                type="number"
                class="form-control"
                :class="{ 'is-invalid': $v.registry.numero.$error }"
                min="1"
                step="1"
                v-model="$v.registry.numero.$model"
              />
              <span
                v-if="!$v.registry.numero.required"
                class="invalid-feedback"
              >
                O campo é obrigatório
              </span>
            </div>
            <div v-if="field === 'dataAbertura'" class="form-group">
              <label>
                Data de Abertura: <span class="text-danger">*</span>
              </label>
              <input
                type="date"
                class="form-control"
                :class="{ 'is-invalid': $v.registry.dataAbertura.$error }"
                v-model="$v.registry.dataAbertura.$model"
              />
              <span
                v-if="!$v.registry.dataAbertura.required"
                class="invalid-feedback"
              >
                O campo é obrigatório
              </span>
            </div>
            <div v-if="field === 'responsavel'" class="form-group">
              <label>
                Setor Responsável: <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                :class="{ 'is-invalid': $v.registry.responsavel.$error }"
                v-model="$v.registry.responsavel.$model"
              />
              <span
                v-if="!$v.registry.responsavel.required"
                class="invalid-feedback"
              >
                O campo é obrigatório
              </span>
            </div>
            <div v-if="field === 'secao'" class="form-group">
              <label>Seção: <span class="text-danger">*</span></label>
              <select
                class="form-control"
                :class="{ 'is-invalid': $v.registry.secao.$error }"
                v-model="$v.registry.secao.$model"
              >
                <option value="">Selecione uma opção</option>
                <option
                  v-for="section in sections"
                  :key="section.codigo"
                  :value="section.codigo"
                  :title="section.nome"
                >
                  {{ section.nome }}
                </option>
              </select>
              <span v-if="!$v.registry.secao.required" class="invalid-feedback">
                O campo é obrigatório
              </span>
            </div>
            <div v-if="field === 'tipo'" class="form-group">
              <label>Tipo: <span class="text-danger">*</span></label>
              <select
                class="form-control"
                :class="{ 'is-invalid': $v.registry.tipo.$error }"
                v-model="$v.registry.tipo.$model"
              >
                <option value="">Selecione uma opção</option>
                <option
                  v-for="type in types"
                  :key="type"
                  :value="type"
                  :title="type"
                >
                  {{ type }}
                </option>
              </select>
              <span v-if="!$v.registry.tipo.required" class="invalid-feedback">
                O campo é obrigatório
              </span>
            </div>
            <div v-if="field === 'descricao'" class="form-group">
              <label>Fato: <span class="text-danger">*</span></label>
              <textarea
                class="form-control"
                :class="{ 'is-invalid': $v.registry.descricao.$error }"
                rows="9"
                v-model="$v.registry.descricao.$model"
              />
              <span
                v-if="!$v.registry.descricao.required"
                class="invalid-feedback"
              >
                O campo é obrigatório
              </span>
            </div>
            <div v-if="field === 'risco'" class="form-group">
              <label>Risco:</label>
              <textarea
                class="form-control"
                rows="9"
                v-model="registry.risco"
              />
            </div>
            <div v-if="field === 'evidencia'" class="form-group">
              <label>Evidência: <span class="text-danger">*</span></label>
              <textarea
                class="form-control"
                :class="{ 'is-invalid': $v.registry.evidencia.$error }"
                rows="9"
                v-model="$v.registry.evidencia.$model"
              />
              <span
                v-if="!$v.registry.evidencia.required"
                class="invalid-feedback"
              >
                O campo é obrigatório
              </span>
            </div>
            <div v-if="field === 'requisito'" class="form-group">
              <label>Requisito: <span class="text-danger">*</span></label>
              <textarea
                class="form-control"
                :class="{ 'is-invalid': $v.registry.requisito.$error }"
                rows="9"
                v-model="$v.registry.requisito.$model"
              />
              <span
                v-if="!$v.registry.requisito.required"
                class="invalid-feedback"
              >
                O campo é obrigatório
              </span>
            </div>
            <div v-if="field === 'acaoCorrecao'" class="form-group">
              <label>
                Ação de Correção (ação imediata para corrigir o problema):
                <span class="text-danger">*</span>
              </label>
              <textarea
                class="form-control"
                :class="{ 'is-invalid': $v.registry.acaoCorrecao.$error }"
                rows="9"
                v-model="$v.registry.acaoCorrecao.$model"
              />
              <span
                v-if="!$v.registry.acaoCorrecao.required"
                class="invalid-feedback"
              >
                O campo é obrigatório
              </span>
            </div>
            <div v-if="field === 'causaNaoConformidade'" class="form-group">
              <label>Identificação da causa da não conformidade:</label>
              <textarea
                class="form-control"
                rows="9"
                v-model="registry.causaNaoConformidade"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-theme"
              title="Atualizar"
              :disabled="disableButton"
            >
              <span v-if="disableButton">
                <i class="fas fa-spinner fa-spin"></i>
              </span>
              <span v-else>Atualizar</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'EditRegistryModal',

  props: {
    registryId: {
      type: String,
      required: true,
    },
    field: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      registry: {
        numero: '',
        dataAbertura: '',
        secao: '',
        responsavel: '',
        tipo: '',
        descricao: '',
        risco: '',
        evidencia: '',
        requisito: '',
        acaoCorrecao: '',
        causaNaoConformidade: '',
      },
      sections: null,
      types: [
        'Não Conformidade',
        'Reclamação de Cliente',
        'Oportunidade de Melhoria',
        'Observação',
        'Prevenção/Risco',
        'Planejamento de Mudanças',
      ],
      disableButton: false,
    }
  },

  computed: {
    sizeModal() {
      const fieldsMini = ['numero', 'dataAbertura', 'responsavel', 'tipo']
      if (fieldsMini.some((v) => this.field.includes(v))) {
        return ''
      }
      return 'modal-lg'
    },
  },

  methods: {
    async getRegistry() {
      try {
        this.registry = await this.$store.dispatch(
          'getRegistry',
          this.registryId,
        )
        if (this.field === 'secao') {
          this.sections = await this.$store.dispatch('getSections')
        }
        window.$('#modaEditRegistry').modal()
      } catch (error) {
        if (error && error.message) {
          this.$root.$children[0].$refs.notification.warning(error.message)
        } else {
          this.$root.$children[0].$refs.notification.danger(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async updateRegistry() {
      this.disableButton = true
      try {
        const response = await this.$store.dispatch('updateRegistry', {
          registryId: this.registryId,
          registry: this.registry,
        })
        this.disableButton = false
        window.$('#modaEditRegistry').modal('hide')
        this.$emit('closeModal', true)
        this.$snotify.success(response.message)
      } catch (error) {
        this.disableButton = false
        if (error && error.message) {
          this.$snotify.warning(error.message, 'Atenção!')
        } else {
          this.$snotify.error(
            'Não foi possível se conectar ao servidor.',
            'Erro!',
          )
        }
      }
    },
  },

  validations: {
    registry: {
      numero: {
        required,
      },
      dataAbertura: {
        required,
      },
      secao: {
        required,
      },
      responsavel: {
        required,
      },
      tipo: {
        required,
      },
      descricao: {
        required,
      },
      evidencia: {
        required,
      },
      requisito: {
        required,
      },
      acaoCorrecao: {
        required,
      },
    },
  },

  mounted() {
    this.getRegistry()
  },
}
</script>
